import moment from 'moment';
import upperFirst from 'lodash/upperFirst';
import isEmpty from 'lodash/isEmpty';

import { convertTimeTo12HoursFormat } from '../common/TimePickerRange/utils';

export const DEFAULT_ZOOM_WITH_PERMISSION = 14;
export const DEFAULT_ZOOM_WITHOUT_PERMISSION = 3;

export const mapStylesCustom = [
  {
    featureType: 'poi',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'poi.park',
    stylers: [
      {
        visibility: 'on',
      },
    ],
  },
];

export const FALLBACK_LOCATION = {
  latitude: 24.78276,
  longitude: 3.084639,
};

export const DAY_OF_WEEK = {
  friday: 'Fri',
  monday: 'Mon',
  saturday: 'Sat',
  sunday: 'Sun',
  thursday: 'Thu',
  tuesday: 'Tue',
  wednesday: 'Wed',
};

export const getMiles = i => {
  return i * 0.000621371192;
};

export function getKeyByValue(object, value) {
  return Object.keys(object).find(key => object[key] === value);
}

export const computeDistanceBetweenLocations = (myLocation, place) => {
  if (myLocation && place) {
    return getMiles(
      google.maps.geometry.spherical.computeDistanceBetween(
        new google.maps.LatLng(myLocation),
        new google.maps.LatLng({
          lat: place.lat || place.geofenceLat,
          lng: place.lng || place.geofenceLng,
        }),
      ),
    ).toFixed(1);
  }
};

export const getCurrentDay = full => {
  return moment().format(full ? 'dddd' : 'ddd');
};

export const currentWorkingHours = (
  formatMessage,
  schedule,
  withDivider,
  details,
) => {
  const closed = formatMessage({ id: 'googleMaps.closed' });

  if (schedule && !isEmpty(schedule)) {
    const divider = withDivider ? ' • ' : '';
    const currentDay = upperFirst(getCurrentDay(false).toLowerCase());
    const target = schedule[getCurrentDay(true).toLowerCase()];
    if (details) {
      if (target && target.startTime) {
        return {
          currentDay,
          workingHours: `${convertTimeTo12HoursFormat(
            target.startTime,
          )}-${convertTimeTo12HoursFormat(target.endTime)}`,
        };
      }
      return {
        currentDay,
        workingHours: closed,
      };
    }
    return target && target.startTime
      ? `${divider}‎${currentDay} ${convertTimeTo12HoursFormat(
          target.startTime,
        )}-${convertTimeTo12HoursFormat(target.endTime)}`
      : `${divider}${currentDay} ${closed}`;
  }
  return '-';
};

export const getWorkingHoursByDay = (dayEntity, dayName, closed) => {
  const currentDay = upperFirst(getCurrentDay(false).toLowerCase());
  const day = DAY_OF_WEEK[dayName];
  const isCurrentDay = day === currentDay;
  if (dayEntity) {
    return {
      day,
      workingHours: `${convertTimeTo12HoursFormat(
        dayEntity.startTime,
      )}-${convertTimeTo12HoursFormat(dayEntity.endTime)}`,
      isCurrentDay: !!isCurrentDay,
    };
  }
  return {
    day,
    workingHours: closed,
    isCurrentDay: !!isCurrentDay,
  };
};

export function CenterControl(controlDiv, map) {
  const controlUI = document.createElement('div');
  controlUI.style.backgroundColor = '#fff';
  controlUI.style.border = '2px solid #fff';
  controlUI.style.boxShadow = '0 2px 6px rgba(0,0,0,.3)';
  controlUI.style.borderRadius = '3px';
  controlUI.style.cursor = 'pointer';
  controlUI.style.marginBottom = '8px';
  controlUI.style.textAlign = 'center';
  controlUI.style.display = 'flex';
  controlUI.style.alignItems = 'center';
  controlUI.style.justifyContent = 'center';
  controlUI.style.width = '40px';
  controlUI.style.height = '40px';
  controlUI.style.marginRight = '10px';
  controlDiv.appendChild(controlUI);
  const controlIcon = document.createElement('div');
  controlIcon.innerHTML =
    '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="32" height="32" viewBox="4 4 24 24"> <defs> <filter id="2h7mbtj58a" width="181.2%" height="181.2%" x="-40.6%" y="-34.4%" filterUnits="objectBoundingBox"> <feOffset dy="2" in="SourceAlpha" result="shadowOffsetOuter1"/> <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation="4"/> <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"/> </filter> <rect id="aueko8y73b" width="32" height="32" x="0" y="0" rx="4"/> </defs> <g fill="none" fill-rule="evenodd"> <use fill="#000" filter="url(#2h7mbtj58a)" xlink:href="#aueko8y73b"/> <use fill="#FFF" xlink:href="#aueko8y73b"/> <path fill="#000" fill-rule="nonzero" d="M15.999 6c.352-.015.651.311.651.652v2.016c.628.055 1.248.19 1.835.405 1.432.526 2.65 1.46 3.536 2.7.746 1.045 1.19 2.297 1.305 3.575h2.022c.365 0 .636.297.651.65.016.353-.31.652-.651.652h-2.023c-.017.184-.04.367-.068.55-.224 1.46-.934 2.84-1.955 3.905-1.01 1.05-2.354 1.806-3.785 2.097-.286.059-.575.102-.867.128v2.018c0 .365-.297.636-.651.651-.352.016-.652-.31-.652-.651v-2.021l-.134-.012c-.689-.08-1.343-.244-1.98-.499l-.318-.135c-1.331-.601-2.467-1.637-3.22-2.884-.576-.949-.929-2.038-1.027-3.146H6.652c-.365 0-.636-.298-.651-.652-.016-.352.31-.652.651-.652h2.02c.14-1.5.725-2.9 1.683-4.065.931-1.134 2.23-1.965 3.64-2.365.44-.125.894-.207 1.352-.248V6.652c0-.365.298-.636.652-.651zm.546 3.964c-.483-.038-.968-.025-1.45.039l.094-.011-.267.044c-.345.066-.685.158-1.016.277l-.252.096-.183.083c-.173.082-.342.171-.508.267l-.245.15c-.137.086-.27.178-.4.275l.038-.028-.04.03.007-.006-.005.004-.002.002.007-.006.028-.02-.018.014-.03.022.008-.007-.022.018.007-.006-.018.014.007-.005-.014.012-.044.036-.196.165c-.25.22-.482.456-.697.71l-.091.111-.017.017-.005.006-.003.004.001-.002-.03.034-.018.03-.018.026-.034.046c-.1.139-.195.282-.284.428-.176.286-.328.586-.459.894l.033-.074-.094.246c-.119.33-.21.67-.277 1.016l-.042.254-.03.282c-.028.362-.028.725 0 1.088l.03.28.042.255c.066.345.158.684.277 1.016l.092.241-.029-.065.031.074.033.078-.031-.079.083.185c.082.174.171.343.267.509l.15.245c.087.137.178.27.275.4l-.023-.033-.003-.003.008.01.01.014.006.009-.01-.015c.009.01.017.021.027.035l.01.012-.005-.005.007.009.01.014-.01-.015.011.014.036.045.165.195c.22.25.456.483.71.698l.111.09.017.017.003.002.004.003.005.004-.006-.004c.015.014.025.024.036.032l.03.018-.006-.005.032.024.046.034c.139.1.282.195.428.284.286.176.586.328.895.458l-.074-.033.245.095c.33.118.67.21 1.016.276l.253.041.283.031c.362.03.726.03 1.088 0l.28-.03.255-.042c.345-.065.685-.158 1.016-.276l.245-.095.19-.084c.173-.082.342-.171.508-.268l.245-.149c.137-.087.27-.178.4-.276l-.037.026.054-.04.014-.012-.003.003.005-.004.014-.01.044-.037c.065-.054.13-.108.196-.165.25-.219.482-.456.697-.71l.09-.11.023-.024c.023-.024.044-.047.05-.066l-.003.002.021-.028.034-.045c.1-.14.195-.283.284-.428.176-.287.328-.586.458-.895l-.036.08-.027.072.03-.074.033-.078-.032.07.094-.241c.118-.331.21-.671.277-1.017l.041-.257.025-.217c.009-.101.016-.202.02-.303l.007-.298.008.088c.047.305.324.573.644.56-.363-.001-.634-.298-.65-.652v-.05l-.001.05c0-.302-.02-.606-.061-.906l.009.089-.042-.262c-.066-.346-.159-.685-.277-1.016l-.097-.251-.082-.184c-.082-.173-.171-.343-.267-.508l-.15-.246c-.087-.136-.178-.269-.276-.4l.029.04-.03-.041.026.036-.04-.051-.006-.009.02.024-.025-.031-.005-.007.004.006-.01-.013-.036-.044-.166-.196c-.219-.25-.456-.482-.71-.697l-.11-.091c-.024-.02-.061-.063-.09-.072l.008.006-.08-.058c-.069-.05-.14-.099-.21-.146l-.217-.139c-.287-.175-.586-.327-.895-.458l.071.032-.242-.093c-.33-.119-.67-.211-1.017-.277l-.268-.044zm-2.574 4.308c.668-.827 1.902-1.16 2.899-.792.547.202.988.54 1.329 1.014.31.43.462.977.469 1.507-.009 1.223-.886 2.367-2.107 2.606-.595.117-1.172.044-1.722-.206-.469-.213-.87-.6-1.133-1.038-.267-.445-.409-.995-.37-1.514.046-.593.261-1.116.635-1.577z"/> </g></svg>';
  controlUI.appendChild(controlIcon);

  const successCurrentLocation = position => {
    const currentPositionEntity = {
      lat: position.coords.latitude,
      lng: position.coords.longitude,
    };

    controlUI.addEventListener('click', () => {
      map.current.context.__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.panTo(
        currentPositionEntity,
      );
    });
  };

  const errorHandlerLocation = () => {
    controlUI.style.display = 'none';
  };

  navigator.geolocation.getCurrentPosition(
    successCurrentLocation,
    errorHandlerLocation,
  );
}



// WEBPACK FOOTER //
// ./src/components/GoogleMaps/utils.js